<template>
  <div class="mainContainer">
    <div v-if="categoryMenu.length > 0"
         class="mainContainer-container">
      <div class="mainContainer-container-leftBox">
        <a-menu v-model:selectedKeys="categoryMenusSelectedKeys"
                mode="horizontal"
                class="menu"
                @click="menusClick">
          <a-menu-item v-for="(item, index) in categoryMenu"
                       :id="String(item.id)"
                       :key="item.id"
                       :index="index"
                       :name="item.name"
                       :class="activeIndex == item.id ? 'activeItem' : ''">
            {{ item.name }}
          </a-menu-item>
        </a-menu>
      </div>
      <div class="mainContainer-container-rightBox">
        <div class="mainContainer-container-rightBox-content">
          <Card v-for="(item, index) in categoryArray"
                :key="index"
                :spu="item"
                :is-home="props.isHome"></Card>
          <a-empty v-if="categoryArray.length == 0 && !spinState"></a-empty>
        </div>
      </div>
    </div>
    <a-empty v-else></a-empty>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref, watch } from "vue"
import { useRoute, useRouter } from "vue-router"
import { categoriesDetail, categoriesTypeMenu } from "../api/categories"
import type { categoriesDetailState, categoriesMenusState } from "../api/interface/categoriesInterface"
import { useProductStore } from "../index"
import Card from "./CategoriesCardPage.vue"
const route = useRoute()
const router = useRouter()
// initialize Startup
onMounted(() => {
  init()
})
const props = defineProps<{
  isHome: boolean
}>()
const init = async () => {
  const selectId = route.query.id
  await getCategoryMenus().then((id) => {
    if (selectId) {
      activeIndex.value = selectId
      getCategoryDetail(selectId as string)
    } else if (id !== null && id !== undefined) {
      activeIndex.value = id
      getCategoryDetail(id as string)
    }
    categoryMenusSelectedKeys.value = []
    categoryMenusSelectedKeys.value.push(activeIndex.value)
  })
}

// declare Type
const categoriesStore = useProductStore()
const categoryMenu = reactive<categoriesMenusState["categories"]>([])
const categoryMenusSelectedKeys = ref<number[]>([])
const spinState = ref<boolean>(false)
const categoryMenuText = ref<string>()
const categoryArray = reactive<Array<categoriesDetailState>>([])
const activeIndex = ref()

// declare Function
const menusClick = (menusItem: { item: { id: string; name: string } }) => {
  const { name, id } = menusItem.item
  categoryMenuText.value = name
  activeIndex.value = id
  getCategoryDetail(id)
  router.push({
    query: { id, name }
  })
}

// declare Method
const getCategoryMenus = (): Promise<string | number> => {
  return new Promise((resolve, reject) => {
    categoriesTypeMenu().then((result) => {
      const { categories } = result
      categoryMenu.length = 0
      categoryMenu.push(...categories)
      if (categoryMenu.length > 0) {
        categoryMenuText.value = categoryMenu.find((item) => item.id === categoriesStore.menusId)?.name || categoryMenu[0].name
        categoryMenusSelectedKeys.value.push((Number(categoriesStore.menusId) as number) || (categoryMenu[0].id as number))
        resolve(categoriesStore.menusId || categoryMenu[0].id)
      }
    })
  })
}
const getCategoryDetail = async (id: string): void => {
  spinState.value = true
  categoryArray.length = 0
  await categoriesDetail(id).then((result) => {
    categoryArray.push(...result.spus)
    spinState.value = false
  })
  categoriesStore.$patch({ menusId: id })
}
watch(
  () => route.query,
  () => {
    init()
  },
  { deep: true }
)
</script>

<style lang="less" scoped>
.mainContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  &-container {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: inline-flex;
    flex-direction: column;
    align-items: flex-end;
    overflow: auto;

    &-leftBox {
      width: 100%;
      padding: 10px 0;
      overflow: hidden;
      overflow-y: auto;

      .ant-menu-horizontal {
        border-bottom: none;
      }

      .menu {
        :deep(.ant-menu-item-selected) {
          background: #111111 !important;
          color: #ffffff;
        }

        :deep(.ant-menu-item-active) {
          border: 1px solid #111111 !important;
        }

        :deep(.ant-menu-item-selected::after) {
          border: 1px solid #111111 !important;
        }

        :deep(.ant-menu-item-active::after) {
          border: 1px solid #111111 !important;
          display: none;
        }

        :deep(.ant-menu-item) {
          margin: 5px 5px 5px 5px;
          border: 1px solid #f1f1f1;
          width: 98px;
          text-align: center;
        }

        :deep(.ant-menu-item:first-child) {
          margin-left: 25px;
        }
      }
    }

    &-rightBox {
      flex: 1;
      width: 100%;
      overflow: hidden;
      overflow-y: auto;

      &-title {
        width: 100%;
        height: 40px;

        &-text {
          font-size: 20px;
          margin-left: 20px;
          margin-top: 5px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          line-height: 28px;
        }
      }

      &-content {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: left;
        align-items: center;

        .ant-empty {
          margin-top: 30px;
        }

        .ant-spin {
          margin-top: 50px;
        }
      }
    }
  }
}

:deep(.ant-spin-container) {
  width: 100%;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
}

:deep(.ant-menu-item-selected) {
  background-color: #fff !important;
}

:deep(.activeItem) {
  background-color: #111111 !important;
  color: #ffffff;
}
</style>
